// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"lemon-slice"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22 10.4882C22 7.55726 19.935 3.90646 18 2L10.5 9.5L3 17C4.90646 18.9349 8.55725 21 11.4882 21C14.391 21 17.0189 19.8234 18.9212 17.9212C20.8234 16.0189 22 13.391 22 10.4882Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10.7632 9.76316L18.65 17.65M11.0391 9.54632L21.75 10.4668M10.5618 10.2188L11.4667 20.75M22 10.4882C22 7.55726 19.935 3.90646 18 2L3 17C4.90646 18.9349 8.55725 21 11.4882 21C17.2937 21 22 16.2937 22 10.4882Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-lemon-slice')
export default class LemonSliceIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lemon-slice',
    }
  }
}
